import api from '../http.service';
import { API_ENDPOINTS } from '@/config/api.config';

export interface Notification {
  id: string;
  tenant_id: string | null;
  user_id: string;
  type: string;
  title: string;
  message: string | null;
  reference_type: string | null;
  reference_id: string | null;
  is_read: boolean;
  read_at: string | null;
  created_at: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  total: number;
  unread: number;
}

const base = API_ENDPOINTS.STUDIO.NOTIFICATIONS;

export const listNotifications = async (params?: {
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
}): Promise<NotificationListResponse> => {
  const response = await api.get(base, { params });
  return response.data.data;
};

export const getUnreadCount = async (): Promise<{ total: number; unread: number }> => {
  const response = await api.get(`${base}/unread-count`);
  return response.data.data;
};

export const markAsRead = async (id: string): Promise<Notification> => {
  const response = await api.patch(`${base}/${id}/read`);
  return response.data.data;
};

export const markAllAsRead = async (): Promise<{ updated: number }> => {
  const response = await api.patch(`${base}/read-all`);
  return response.data.data;
};
